import { Component, Input } from '@angular/core';
import { WebsocketService } from '../../services/websocket.service';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { JobsActions } from '../../store/jobs/jobs.actions';
import { ResponsiveService } from '../../services/reponsive.service';
import { Observable } from 'rxjs';
import { routeTransition } from '../../route-transition';
import { SideBarComponent } from '../../components/side-bar/side-bar.component';
import { ClientActions } from '../../store/client/client.actions';
import { selectJobsIsLoaded } from '../../store/jobs/jobs.selects';
import { WsMessage } from '../../models/ws-message.model';
import { Plan } from '../../class/plan.class';
import { WsUpdateTaskMessage } from '../../models/ws-update-task-message.model';
import { PlanModel } from '../../models/plan.model';

@Component({
  selector: 'app-dashboard',
  imports: [RouterOutlet, SideBarComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  animations: [routeTransition],
})
export class DashboardComponent {
  @Input() open: boolean = false;

  // Responsives
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  constructor(
    private websocketService: WebsocketService,
    private store: Store,
    private responsiveService: ResponsiveService,
    protected route: ActivatedRoute,
  ) {
    this.store.dispatch(ClientActions.loadClient());
    this.store.select(selectJobsIsLoaded).subscribe((isLoaded: boolean) => {
      if (!isLoaded) {
        this.store.dispatch(JobsActions.loadJobs());
      }
    });
    this.websocketService.messages$.subscribe((wsMessage: WsMessage) => {
      switch (wsMessage.type) {
        case 'ACTIVE_PLAN':
          const plan: Plan = new Plan(wsMessage.content.plan as PlanModel);
          this.store.dispatch(ClientActions.setPlan({ plan }));
          this.store.dispatch(
            ClientActions.addTokens({ tokens: plan.tokensPerMonth }),
          );
          break;

        case 'TASK':
          this.store.dispatch(
            JobsActions.updateJobFromWsMessage({
              wsUpdateTaskMessage: wsMessage.content as WsUpdateTaskMessage,
            }),
          );
          break;

        case 'JOB_COMPLETED':
          this.store.dispatch(
            JobsActions.updateJobFromWsMessage({
              wsUpdateTaskMessage: wsMessage.content as WsUpdateTaskMessage,
            }),
          );
          break;

        case 'TRANSLATE_PARAMS':
          const message = wsMessage.content;
          const translatePramsMessage: WsUpdateTaskMessage = {
            id: message.id,
            job: message.job.id,
            type: message.type,
            status: message.status,
            message: message.message,
            progress: message.progress,
            updated_at: message.updated_at,
            created_at: message.created_at,
          };
          this.store.dispatch(
            JobsActions.updateJobFromWsMessage({
              wsUpdateTaskMessage: translatePramsMessage,
            }),
          );
          break;
        case 'PING':
          websocketService.sendMessage({ type: 'PONG' });
          break;
        case 'ERROR':
          // this.store.dispatch(ClientActions.wsError({ errorMessage: message }))
          break;

        default:
          console.error('WebSocket message has no type.');
      }
    });
  }
}
